import ApiService from 'Services/ApiService';
import ReactGA from 'react-ga';
import { getCookie } from '../../Services/CookiesService';

export async function trackEvent(action, label = '') {
  const data = { ...data, idUtPipl: getCookie('_id_ut_pipl'), trackCategory: 'SIGN_UP', label, action };

  try {
    await ApiService.eventTracking(data);
  } catch (e) {
    // log
  }
}
const googleAnalyticsTrackingId = window.__CONFIG__.GA_TRACKING_ID;

export function trackPage(path) {
  // update GA
  ReactGA.initialize(googleAnalyticsTrackingId);
  ReactGA.set({ page: path });
  ReactGA.pageview(path);

  // update HS
  const _hsq = window._hsq || [];
  _hsq.push(['setPath', path]);
  _hsq.push(['trackPageView']);

  // update VWO
  const _vwo = window.VWO || [];
  _vwo.push(['activate', { customUrl: path }]);
}
